<template>
    <BaseCollapsible>
        <template #trigger>
            <CalEvent
                :title="subject"
                :start-time="startTimeObject"
                :end-time="endTimeObject"
                :attendees="attendees ?? []"
                hide-attendees
                show-date
                class="text-left mb-2"
                :class="tonalThemeEnabled ? 'w-full max-w-60' : 'border rounded-tr-lg rounded-br-lg bg-white max-w-60'" />
        </template>
        <template #content>
            <CalendarAttendees v-if="attendees?.length" :attendees="attendees" />
        </template>
    </BaseCollapsible>
</template>

<script setup lang="ts">
import BaseCollapsible from "~vue/components/BaseCollapsible.vue";
import CalendarAttendees from "~vue/components/CalendarIntegration/CalendarAttendees.vue";
import CalEvent from "~vue/components/CalendarIntegration/CalEvent.vue";
import { tonalThemeEnabled } from "~vue/utils/theme";
import { DateTime } from "luxon";
import { computed } from "vue";

const props = defineProps<{
    subject: string;
    startTime: string;
    endTime: string;
    attendees?: Array<{ name: string; email: string }>;
}>();

// TODO: Remove the legacy calendar branch once the tonal theme becomes the default.

const startTimeObject = computed(() => DateTime.fromISO(props.startTime, { setZone: true }));
const endTimeObject = computed(() => DateTime.fromISO(props.endTime, { setZone: true }));
</script>
